import styled from "styled-components";

export const Tags = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RecruiterContent = styled.div`
  border-radius: 8px;
  border: 1px solid #eee;
  background: #fff;
  padding: 16px;
  margin: 24px 0;
`;

export const RecruiterTitle = styled.h5`
  color: #333;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0 0 8px 0;
`;

export const RecruiterFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const RecruiterName = styled.h4`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin: 0 0 2px 0;
`;

export const RecruiterEmail = styled.a`
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const RecruiterLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;
